/**
 * getEngagementRate - A function to calculate the engagement rate as a percentage.
 *
 * @param {number} totalAttendance - The total number of attendees or users who have participated.
 * @param {number} totalTaps - The total number of taps or actions performed by the attendees/users.
 *
 * @returns {string} - Returns the engagement rate as a percentage with one decimal place (e.g., "12.3%").
 * If totalAttendance is zero or less, it returns '0.0%' to prevent division by zero.
 */
export const getEngagementRate = (totalAttendance, totalTaps) => {
    // Calculate engagement rate only if attendance is greater than zero
    const totalEngagement = totalAttendance > 0
        ? ((totalTaps / totalAttendance) * 100).toFixed(1)   // Calculate and format the engagement rate
        : '0.0%';  // Return '0.0%' if attendance is zero or less
    return totalEngagement;
}
